import React from 'react'

import translations from '@/translations/homepage2'
import BottomCTA from '@/components/sections/new-landing/BottomCTA/BottomCTA'
import Hero from '@/components/sections/new-landing/Hero/Hero'
import HowItWorks from '@/components/sections/new-landing/HowItWorks/HowItWorks'
import LogoMarquee from '@/components/sections/new-landing/LogoMarquee/LogoMarquee'
import Testimonials from '@/components/sections/new-landing/Testimonials/Testimonials'
import WhyNeat from '@/components/sections/new-landing/WhyNeat/WhyNeat'

import styles from './new-landing.module.scss'

export default function NewLanding() {
  return (
    <div className={styles.container}>
      <main>
        <Hero t={translations.hero} />
        <LogoMarquee t={translations.marquee} />
        <HowItWorks t={translations.howItWorks} />
        <Testimonials t={translations.testimonials} />
        <WhyNeat t={translations.whyNeat} />
        <BottomCTA t={translations.bottomCta} />
      </main>
    </div>
  )
}
